import { atom } from 'jotai';
import { getBootstrapInfoFromLocal } from 'utils/js/bootstrapper';

export const bootstrapInfos = atom(getBootstrapInfoFromLocal());
